import { TS_ItemIncluded }      from '../TravelSeller/Models/TS_ItemIncluded';
import { BookingItemInterface } from './BookingItemInterface';

export class ItemIncluded extends TS_ItemIncluded implements BookingItemInterface {}